import React, { useState } from 'react'
import PropTypes from 'prop-types'
// import moment from 'moment'
import R from 'ramda'

import {
  Button,
  Segment,
  Grid
} from 'semantic-ui-react'

import {
  // toTitle,
  // productNameToUpper,
  // getFsUrl
  notNilOrEmpty
} from '_utils'

import {
  PAGES
} from '_constants'

import LineItem from '_views/lineItem'
import Transfer from './transfer'
import DeactivateForm from './deactivate'
import useCanAdminLicenses from '../../hooks/useCanAdminLicenses'

const getInvoiceId = R.propOr('unkown', 'invoice_id')
const getInvoiceXeroId = R.propOr('unkown', 'xero_id')
const getInvoiceNumber = R.propOr('unkown', 'invoice_number')
const getInvoiceDate = R.propOr('unkown', 'date')
const getInvoiceDueDate = R.propOr('unkown', 'due_date')
const getDescription = R.propOr('unkown', 'description')
const getLineItemId = R.propOr('unkown', 'line_item_id')
const getStatus = R.propOr('unkown', 'status')
const getCode = R.propOr('unkown', 'code')
const getQuantity = R.propOr('unkown', 'quantity')
const getAmount = R.propOr('unkown', 'amount')

const getOriginalInfo = org => R.prop('name', org)

const TransferredTo = ({
  reseller,
  institution,
  invoice,
  onClick
}) => reseller && reseller._id && invoice && invoice.institution_id
  ? <LineItem label='Transferred To' text={getOriginalInfo(invoice.to_institution)} onClick={onClick} />
  : institution && institution._id && invoice && invoice.institution_id && invoice.institution_id !== institution._id
    ? <LineItem label='Transferred To' text={getOriginalInfo(invoice.to_institution)} onClick={onClick} />
    : null

TransferredTo.propTypes = {
  invoice: PropTypes.object.isRequired,
  reseller: PropTypes.object,
  institution: PropTypes.object,
  onClick: PropTypes.func.isRequired
}

const OriginalAccount = ({
  reseller,
  institution,
  invoice,
  onClick
}) => (invoice && invoice.original_institution && !(institution && institution.xero_id === invoice.xero_id))
  ? <LineItem label='Original Institution' text={getOriginalInfo(invoice.original_institution)} onClick={onClick} />
  : (invoice && invoice.original_reseller && !(reseller && reseller.xero_id === invoice.xero_id))
    ? <LineItem label='Original Reseller' text={getOriginalInfo(invoice.original_reseller)} onClick={onClick} />
    : null

OriginalAccount.propTypes = {
  invoice: PropTypes.object.isRequired,
  reseller: PropTypes.object,
  institution: PropTypes.object,
  onClick: PropTypes.func.isRequired
}

const TransferButton = ({
  reseller,
  institution,
  invoice,
  disabled,
  onClick
}) => reseller && reseller._id && invoice && invoice.institution_id
  ? null
  : institution && institution._id && invoice && invoice.institution_id && invoice.institution_id !== institution._id
    ? null
    : <Button primary content='transfer' size='mini' onClick={onClick} disabled={disabled}/>

TransferButton.propTypes = {
  invoice: PropTypes.object.isRequired,
  reseller: PropTypes.object,
  institution: PropTypes.object,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}
const amTertiary = (reseller = {}, institution = {}, invoice = {}) => (
  R.propEq('xero_id', getInvoiceXeroId(invoice), reseller) &&
  notNilOrEmpty(R.prop('institution_id', invoice))
) || (
  R.propEq('xero_id', getInvoiceXeroId(invoice), institution) &&
  notNilOrEmpty(R.prop('institution_id', invoice)) &&
  R.prop('institution_id', invoice) !== R.prop('_id', institution)
) || notNilOrEmpty(R.prop('deactivated_by', invoice))

const DeactivateButton = ({
  invoice,
  disabled,
  onClick
}) => invoice && notNilOrEmpty(invoice.deactivated_by)
  ? null
  : <Button negative content='deactivate' size='mini' onClick={onClick} disabled={disabled}/>

DeactivateButton.propTypes = {
  invoice: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}

const ACTIVE_VIEW = {
  INFO: 0,
  TRANSFER: 1,
  DEACTIVATE: 2
};

const XeroInvoice = props => {
  const canAdmin = useCanAdminLicenses();
  const [activeView, setActiveView] = useState(ACTIVE_VIEW.INFO);

  const cancelAll = () => setActiveView(ACTIVE_VIEW.INFO);
  const startTransfer = () => setActiveView(ACTIVE_VIEW.TRANSFER);
  const startDeactivate = () => setActiveView(ACTIVE_VIEW.DEACTIVATE);

  const onTransfer = (invoice, institution) => {
    cancelAll();
    if (props.onTransfer) {
      props.onTransfer(invoice, institution);
    }
  };

  const onDeactivate = (invoice) => {
    cancelAll();
    if (props.onDeactivate) {
      props.onDeactivate(invoice);
    }
  };

  const goToInstitution = e => {
    const institutionId = R.path(['invoice', 'institution_id'], props);
    props.setNavigation({pageName: PAGES.INSTITUTIONS, pageNum: 1, ids: [institutionId]});
  };

  const goToOriginalAccount = e => {
    const institutionId = R.path(['invoice', 'original_institution', '_id'], props)
    const resellerId = R.path(['invoice', 'original_reseller', '_id'], props)
    return institutionId
      ? props.setNavigation({pageName: PAGES.INSTITUTIONS, pageNum: 1, ids: [institutionId]})
      : resellerId
        ? props.setNavigation({pageName: PAGES.RESELLERS, pageNum: 1, ids: [resellerId]})
        : null
  };

  const { reseller, institution, invoice } = props;
  return (
    <Segment
      tertiary={amTertiary(reseller, institution, invoice)}
    >
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column width={8}>
            <LineItem label='Invoice Number' text={getInvoiceNumber(invoice)} />
            <OriginalAccount reseller={reseller} institution={institution} invoice={invoice} onClick={goToOriginalAccount} />
            <TransferredTo reseller={reseller} institution={institution} invoice={invoice} onClick={goToInstitution} />
            <LineItem label='Code' text={getCode(invoice)} />
            <LineItem label='Status' text={getStatus(invoice)} />
            <LineItem label='Description' text={getDescription(invoice)} />
            <LineItem label='Deactivated by' text={R.path(['deactivated_by', 'displayname'], invoice)} />
            <LineItem label='Deactivation reason' text={R.path(['deactivated_reason'], invoice)} />
            {
              canAdmin ? (
                <Button.Group size='mini'>
                  <DeactivateButton
                    invoice={invoice}
                    onClick={startDeactivate}
                    disabled={activeView !== ACTIVE_VIEW.INFO}
                  />
                  <TransferButton
                    institution={institution}
                    reseller={reseller}
                    invoice={invoice}
                    onClick={startTransfer}
                    disabled={activeView !== ACTIVE_VIEW.INFO}
                  />
                </Button.Group>
              ) : null
            }
          </Grid.Column>
          <Grid.Column width={8}>
            {
              activeView === ACTIVE_VIEW.TRANSFER ? (
                <Transfer
                  invoice={invoice}
                  onTransfer={onTransfer}
                  onCancel={cancelAll}
                />
              ) : null
            }
            {
              activeView === ACTIVE_VIEW.DEACTIVATE ? (
                <DeactivateForm
                  invoice={invoice}
                  onDeactivate={onDeactivate}
                  onCancel={cancelAll}
                />
              ) : null
            }
            {
              activeView === ACTIVE_VIEW.INFO ? (
                <React.Fragment>
                  <LineItem label='Invoice Id' text={getInvoiceId(invoice)} />
                  <LineItem label='Line Item Id' text={getLineItemId(invoice)} />
                  <LineItem label='Date' text={getInvoiceDate(invoice)} isDate={true} />
                  <LineItem label='Due Date' text={getInvoiceDueDate(invoice)} isDate={true} />
                  <LineItem label='Quantity' text={getQuantity(invoice)} />
                  <LineItem label='Amount' text={getAmount(invoice)} />
                </React.Fragment>
              ) : null
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}

XeroInvoice.propTypes = {
  invoice: PropTypes.object.isRequired,
  institution: PropTypes.object,
  reseller: PropTypes.object,
  onTransfer: PropTypes.func.isRequired,
  onDeactivate: PropTypes.func.isRequired,
  setNavigation: PropTypes.func.isRequired
}

export default XeroInvoice



// WEBPACK FOOTER //
// ./webAdmin/views/xero/invoice.js